export const enum OrderAdjustmentsTypes {
  OrderAmount = 'order_amount',
  StatusToSuccess = 'status_to_success',
  StatusToRefund = 'status_to_refund',
  StatusToChargeback = 'status_to_chargeback',
  StatusToFailure = 'status_to_failure',
  StatusToCanceled = 'status_to_cancelled',
}
